"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldNameConverter = void 0;
class FieldNameConverter {
    // cgdocument.doclabel ==> cgdocument_doclabel
    // cgdocument.doclabel_icon ==> cgdocument_doclabel_icon
    static toInternalName(fieldName) {
        return fieldName.replace(/\./, "_");
    }
    // cgdocument_doclabel ==> cgdocument.doclabel
    // cgdocument_doclabel_icon ==> cgdocument.doclabel_icon
    static fromInternalName(internalName) {
        const idx = internalName.indexOf("_");
        return internalName.substring(0, idx) + "." + internalName.substring(idx + 1);
    }
}
exports.FieldNameConverter = FieldNameConverter;
